import { render, staticRenderFns } from "./AnnouncementsIndex.vue?vue&type=template&id=a2be258c&"
import script from "./AnnouncementsIndex.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsIndex.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsIndex.vue?vue&type=style&index=0&id=a2be258c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports